import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

import { RdsTabulationSortOptionsComponent } from './tabulation-sort-options.component';

@NgModule({
  imports: [CommonModule, FlexLayoutModule, FormsModule, MatButtonModule, MatIconModule, MatTooltipModule],
  exports: [RdsTabulationSortOptionsComponent],
  declarations: [RdsTabulationSortOptionsComponent],
})
export class RdsTabulationSortOptionsModule {}

export * from './tabulation-sort-options.component';
